import { useState, useRef, useEffect } from 'react';

export function useOverlayThatClosesOnOutsideClick() {
  const [isOpen, setOpen] = useState(false);
  const containerRef = useRef(null);

  const open = () => setOpen(true);
  const close = () => setOpen(false);
  const toggle = () => setOpen(prevOpen => !prevOpen);

  useEffect(
    () => {
      if (!isOpen) {
        return;
      }

      function closeModalOnOutsideClick(event) {
        if (!containerRef.current) return;
        if (!containerRef.current.contains(event.target)) {
          close();
        }
      }

      window.addEventListener('click', closeModalOnOutsideClick);

      return () => {
        window.removeEventListener('click', closeModalOnOutsideClick);
      };
    },
    [isOpen]
  );

  return {
    containerRef,
    isOpen,
    open,
    close,
    toggle,
  };
}
